export default "__VITE_ASSET__Dep4mVw___"